import React, { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  Checkbox,
  Dropdown,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { utils, writeFileXLSX } from "xlsx";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getUserList,
  getClientid,
  getUserInfo,
} from "redux/selectors";
import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,
} from "common/Constants";
import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  addMonthinDate,
} from "utils/Date";
import COLORS from "common/Colors";
import { concat, find, get, includes, orderBy } from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import dayjs from "dayjs";
import { SortAscendingOutlined } from "@ant-design/icons";

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  a {
    color: #2d53da !important;
    :hover {
      color: #2d53da;
    }
    :active {
      color: #2d53da;
    }
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }

  a {
    color: #2d53da !important;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }

  .ant-form-item {
    display: inline-block;
  }

  .outer-form {
    margin-right: 0px;
  }

  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
    display: flex;
    align-items: center; /* ⭐ key */
  }

  /* Placeholder */
  .ant-select-selection-placeholder {
    color: #000 !important;
    font-weight: 400;
  }

  /* Arrow & clear icon */
  .ant-select-arrow,
  .ant-select-clear {
    top: 50% !important;
    transform: translateY(-50%);
  }

  /* Input / button alignment */
  .ant-input-affix-wrapper,
  .ant-input,
  .ant-btn {
    display: flex;
    align-items: center;
  }
`;
const StyledButton = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 768px) {
    margin-left: -40px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
function Approval({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userList,
  userInfo,
}) {
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  const [form] = Form.useForm();
  const [filterList, setFilterList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);
  const [activeSortColumn, setActiveSortColumn] = useState([]);
  const [uiTableData, setUITableData] = useState([]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setUITableData(extra.currentDataSource);
  };

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };

  const STAFF_LIST = React.useMemo(() => {
    const unique = new Map();
    userList.forEach((val) => {
      unique.set(val.userid, {
        value: val.userid,
        label: val.fullname,
      });
    });
    return Array.from(unique.values()).sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );
  }, [userList]);

  const filterattentancereport = attendanceList.filter((val) => {
    if (form.getFieldValue("staff_name") === "") {
      return val;
    } else if (val?.userid === form.getFieldValue("staff_name")) {
      return val;
    }
  });

  const generateHourMinutesFromMinutes = (minutes) => {
    const sign = minutes < 0 ? "-" : "";
    const absMinutes = Math.abs(minutes);

    const hours = Math.floor(absMinutes / 60);
    const mins = absMinutes % 60;

    return `${sign}${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
  };

  const getToltalWorkHours = (record) => {
    if (!record.checkoutdate || !record.checkouttime) return "00:00";

    const checkinDateTime = dayjs(
      `${dayjs(record.checkindate).format("YYYY-MM-DD")} ${record.checkintime}`,
      "YYYY-MM-DD HH:mm:ss"
    );

    const checkoutDateTime = dayjs(
      `${dayjs(record.checkoutdate).format("YYYY-MM-DD")} ${
        record.checkouttime
      }`,
      "YYYY-MM-DD HH:mm:ss"
    );

    const diffInSeconds = checkoutDateTime.diff(checkinDateTime, "second");

    if (diffInSeconds <= 0) return "00:00";

    // ❌ remove Math.round
    const diffInMinutes = Math.floor(diffInSeconds / 60); // ✅ exact minutes

    return generateHourMinutesFromMinutes(diffInMinutes);
  };

  const parseHourMinutesToMinutes = (time = "00:00") => {
    if (!time || time === "-") return 0;
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };

  const minutesToHourMinutes = (minutes = 0) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "fullname",
      key: "fullname",
      width: 200,
      render: (fullName) => {
        if (fullName !== ("" || null || undefined)) {
          return fullName;
        } else {
          return "-";
        }
      },
    },

    {
      title: "Check-in date",
      dataIndex: "checkindate",
      key: "checkindate",
      width: 150,
      render: (checkinDate) => {
        if (checkinDate === ("" || null || undefined)) return "-";
        const checkinDateFormat = moment(checkinDate).format("DD MMM YYYY");
        return `${checkinDateFormat}`;
      },
    },

    {
      title: "Check-in time",
      dataIndex: "checkintime",
      key: "checkintime",
      width: 150,
    },
    {
      title: "Check-in day",
      dataIndex: "checkinday",
      key: "checkinday",
      width: 150,
      render: (checkinDate, record) => {
        if (record?.checkindate === ("" || null || undefined)) return "-";
        const getdayAlone = moment(record?.checkindate).format("dddd");
        return `${getdayAlone}`;
      },
    },
    {
      title: "Check-out time",
      dataIndex: "checkouttime",
      key: "checkouttime",
      width: 150,
      render: (checkoutDateTime) => {
        if (
          checkoutDateTime === null ||
          checkoutDateTime === "" ||
          checkoutDateTime === undefined
        ) {
          return "-";
        } else {
          // const { time24 } = dateInDetail(checkoutDateTime);
          return checkoutDateTime;
        }
      },
    },
    {
      title: "Check-out date",
      dataIndex: "checkoutdate",
      key: "checkoutdate",
      width: 150,
      render: (checkoutDate) => {
        if (
          checkoutDate === null ||
          checkoutDate === "" ||
          checkoutDate === undefined
        ) {
          return "-";
        } else {
          const dateFormat = moment(checkoutDate).format("DD MMM YYYY");
          return `${dateFormat}`;
        }
      },
    },

    {
      title: "Check-out day",
      dataIndex: "checkoutday",
      key: "checkoutday",
      width: 150,
      render: (checkoutDate, record) => {
        if (
          record?.checkoutdate === null ||
          record?.checkoutdate === "" ||
          record?.checkoutdate === undefined
        ) {
          return "-";
        } else {
          const getdayAlone = moment(record?.checkoutdate).format("dddd");
          return `${getdayAlone}`;
        }
      },
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: 130,
    },

    {
      title: "Department",
      dataIndex: "departmentname",
      key: "departmentname",
      width: 180,
      render: (departmentName) => {
        if (departmentName !== ("" || null || undefined)) {
          return departmentName;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Checkin Station",
      dataIndex: "loginlocationname",
      key: "loginlocationname",
      width: 200,
      render: (loginlocationname) => {
        if (loginlocationname !== ("" || null || undefined)) {
          return loginlocationname;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Checkout Type",
      dataIndex: "checkouttype",
      key: "checkouttype",
      width: 150,
      render: (checkouttype, record) => {
        if (checkouttype && record?.checkoutdate) {
          return checkouttype;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Check-in Coordinates",
      dataIndex: "loginlatitude",
      key: "loginlatitude",
      width: 240,
      render: (_, record) => {
        const url1 =
          "http://maps.google.com/maps/?q=" +
          record.loginlatitude +
          "," +
          record.loginlongitude +
          "";
        return (
          <div>
            {record.loginlatitude !== ("" || null || undefined) &&
            record.loginlongitude !== ("" || null || undefined) ? (
              <>
                <div id="loc">
                  <a href={url1} target="_blank">
                    {record.loginlatitude},{record.loginlongitude}
                  </a>
                </div>
              </>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Checkout Station",
      dataIndex: "logoutlocationname",
      key: "logoutlocationname",
      width: 200,
      render: (logoutLocationName) => {
        if (
          logoutLocationName === null ||
          logoutLocationName === "" ||
          logoutLocationName === undefined
        ) {
          return "-";
        } else {
          return logoutLocationName;
        }
      },
    },

    {
      title: "Check-out Coordinates",
      dataIndex: "end_lat_long",
      key: "logoutlatitude",
      width: 240,
      render: (_, record) => {
        const url =
          "http://maps.google.com/maps/?q=" +
          record.logoutlatitude +
          "," +
          record.logoutlongitude +
          "";
        return (
          <div>
            {record.logoutlatitude === null ||
            record.logoutlatitude === "" ||
            (record.logoutlatitude === undefined &&
              record.logoutlongitude === null) ||
            record.logoutlongitude === "" ||
            record.logoutlongitude === undefined ? (
              "-"
            ) : (
              <>
                <div>
                  <a href={url} target="_blank">
                    {record.logoutlatitude},{record.logoutlongitude}
                  </a>
                </div>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Total Work Duration",
      dataIndex: "totalworkedhours",
      key: "totalworkedhours",
      width: 220,
      render: (_, record) => {
        if (record.checkoutdate) {
          return record?.totalworkedhours;
        }
        return "00:00";
      },
    },
  ];

  const columnsWithSorting = columns.map((col) => ({
    ...col,
    sorter: activeSortColumn.includes(col.dataIndex)
      ? (a, b) => {
          // Handle check-in day
          if (col.dataIndex === "checkinday") {
            return moment(a.checkindate).day() - moment(b.checkindate).day();
          }

          // Handle check-out day
          if (col.dataIndex === "checkoutday") {
            return moment(a.checkoutdate).day() - moment(b.checkoutdate).day();
          }

          // Handle Check-in Coordinates (sort by latitude)
          if (col.dataIndex === "loginlatitude") {
            const aVal = parseFloat(a.loginlatitude) || 0;
            const bVal = parseFloat(b.loginlatitude) || 0;
            return aVal - bVal;
          }

          // Handle Check-out Coordinates (sort by latitude)
          if (col.dataIndex === "end_lat_long") {
            const aVal = parseFloat(a.logoutlatitude) || 0;
            const bVal = parseFloat(b.logoutlatitude) || 0;
            return aVal - bVal;
          }

          // Handle Total Work Duration
          if (col.dataIndex === "overtimeDuration") {
            const aDuration = a.checkoutdate ? getToltalWorkHours(a) : "00:00";
            const bDuration = b.checkoutdate ? getToltalWorkHours(b) : "00:00";
            const aMinutes = parseHourMinutesToMinutes(aDuration);
            const bMinutes = parseHourMinutesToMinutes(bDuration);
            return aMinutes - bMinutes;
          }

          const aVal = a[col.dataIndex];
          const bVal = b[col.dataIndex];

          // Date sort
          if (moment(aVal, moment.ISO_8601, true).isValid()) {
            return moment(aVal).valueOf() - moment(bVal).valueOf();
          }

          // String sort
          if (typeof aVal === "string") {
            return aVal.localeCompare(bVal);
          }

          // Number sort
          return (aVal ?? 0) - (bVal ?? 0);
        }
      : false,
  }));

  const SORT_OPTIONS = columns.map((col) => ({
    label: col.title,
    value: col.dataIndex,
  }));

  const finalColumns =
    activeSortColumn.length > 0
      ? columnsWithSorting.filter((col) =>
          activeSortColumn.includes(col.dataIndex)
        )
      : columnsWithSorting;

  const sortMenu = (
    <div
      style={{
        padding: 12,
        width: 200,
        maxHeight: 300,
        overflowY: "scroll",
        background: "#fff",
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
        fontWeight: 400,
      }}
    >
      <Checkbox.Group
        value={activeSortColumn}
        options={SORT_OPTIONS}
        onChange={(values) => setActiveSortColumn(values)}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}
      />
    </div>
  );

  useEffect(() => {
    getAttendanceReport();
  }, [
    selectedDepartmentId,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
  ]);

  const getAttendanceReport = async () => {
    list();
    return new Promise(async (resolve, reject) => {
      setAttendanceList([]);
      const { start_date, end_date, duration_type, month } =
        form.getFieldsValue();
      setDisplayTableLoader(true);
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(find(MONTH_LIST, { value: month }), "index", 0)
      );
      const { code, attendanceList = [] } = await CALL_API(
        `attendance-report/${ClientId}`,
        "post",
        {
          department: [""],
          //selectedDepartmentId
          start_date: getMySqlDate(
            duration_type === 2 ? startDateOfMonth : start_date
          ),
          end_date: getMySqlDate(
            duration_type === 2 ? lastDateOfMonth : end_date
          ),
          reportingmanager: userInfo?.userid,
        }
      );
      setDisplayTableLoader(false);
      if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
        const sortedData = attendanceList.sort((a, b) => {
          const timeA = moment(a.checkintime, "HH:mm:ss");
          const timeB = moment(b.checkintime, "HH:mm:ss");
          return timeB - timeA;
        });
        setAttendanceList(orderBy(sortedData, ["checkindatetime"], ["desc"]));
        console.log(
          "datas-->",
          sortedData?.filter((val) => val?.userid === "ambokavanessa@gmail.com")
        );
      }
    });
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const getAttendanceSummary = (data) => {
    let totalMinutes = 0;

    data.forEach((record) => {
      if (record.checkoutdate) {
        const duration = getToltalWorkHours(record); // "HH:mm"
        totalMinutes += parseHourMinutesToMinutes(duration);
      }
    });

    return {
      label: "Sub Total",
      totalWorkDuration: minutesToHourMinutes(totalMinutes),
    };
  };

  // const xport = React.useCallback(() => {
  //   const elt = document.getElementById("Table");
  //   const wb = utils.table_to_book(elt);
  //   writeFileXLSX(wb, "attendance-report.xlsx");
  // });

  const xport = React.useCallback(() => {
    const exportData = uiTableData.length
      ? uiTableData
      : filterattentancereport;

    if (!exportData?.length) return;

    let totalWorkMinutes = 0;

    const rows = exportData.map((record) => {
      const row = {};

      finalColumns.forEach((col) => {
        const key = col.dataIndex;
        const title = col.title;
        console.log("key-->", key);
        if (key === "checkinday") {
          row[title] = record.checkindate
            ? moment(record.checkindate).format("dddd")
            : "-";
        } else if (key === "checkindate") {
          row[title] = record.checkindate
            ? moment(record.checkindate).format("DD-MM-YYYY")
            : "-";
        } else if (key === "checkoutdate") {
          row[title] = record.checkoutdate
            ? moment(record.checkoutdate).format("DD-MM-YYYY")
            : "-";
        } else if (key === "checkoutday") {
          row[title] = record.checkoutdate
            ? moment(record.checkoutdate).format("dddd")
            : "-";
        } else if (title === "Check-in Coordinates") {
          if (record.loginlatitude && record.loginlongitude) {
            const url =
              "http://maps.google.com/maps/?q=" +
              record.loginlatitude +
              "," +
              record.loginlongitude;

            // export clickable link
            row[
              title
            ] = `${record.loginlatitude},${record.loginlongitude} (${url})`;
          } else {
            row[title] = "-";
          }
        }

        // 📍 Check-out coordinates
        else if (title === "Check-out Coordinates") {
          if (record.logoutlatitude && record.logoutlongitude) {
            const url =
              "http://maps.google.com/maps/?q=" +
              record.logoutlatitude +
              "," +
              record.logoutlongitude;

            row[
              title
            ] = `${record.logoutlatitude},${record.logoutlongitude} (${url})`;
          } else {
            row[title] = "-";
          }
        } else if (key === "totalworkedhours") {
          if (record.checkoutdate) {
            const duration = getToltalWorkHours(record);
            row[title] = duration;

            totalWorkMinutes += parseHourMinutesToMinutes(duration);
          } else {
            row[title] = "00:00";
          }
        } else {
          row[title] = record[key] ?? "-";
        }
      });

      return row;
    });

    /* -------- subtotal row -------- */
    const subtotalRow = {};
    finalColumns.forEach((col, index) => {
      console.log("col-->", col);
      if (col.dataIndex === "fullname") {
        subtotalRow[col.title] = "Sub Total";
      } else if (col.dataIndex === "totalworkedhours") {
        subtotalRow[col.title] = minutesToHourMinutes(totalWorkMinutes);
      } else {
        subtotalRow[col.title] = "";
      }
    });

    rows.push(subtotalRow);

    const ws = utils.json_to_sheet(rows);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Attendance Report");
    writeFileXLSX(wb, "attendance-report.xlsx");
  }, [filterattentancereport, uiTableData, finalColumns]);

  // const xport = React.useCallback(() => {
  //   const exportData = uiTableData.length
  //     ? uiTableData
  //     : filterattentancereport;
  //   if (!exportData?.length) return;

  //   const summary = getAttendanceSummary(exportData);

  //   // 1️⃣ Convert table data manually
  //   const rows = exportData.map((record) => ({
  //     "Employee ID": record.employeeid || "-",
  //     "Employee Name": record.fullname || "-",
  //     Department: record.departmentname || "-",
  //     "Check-in Date": record.checkindate
  //       ? moment(record.checkindate).format("DD MMM YYYY")
  //       : "-",
  //     "Check-in Time": record.checkintime || "-",
  //     "Check-out Date": record.checkoutdate
  //       ? moment(record.checkoutdate).format("DD MMM YYYY")
  //       : "-",
  //     "Check-out Time": record.checkouttime || "-",
  //     "Total Work Duration": record.checkoutdate
  //       ? getToltalWorkHours(record)
  //       : "00:00",
  //   }));

  //   // 2️⃣ Append summary row
  //   rows.push({
  //     "Employee ID": "",
  //     "Employee Name": "",
  //     Department: "",
  //     "Check-in Date": "",
  //     "Check-in Time": "",
  //     "Check-out Date": "",
  //     "Check-out Time": "Sub Total",
  //     "Total Work Duration": summary.totalWorkDuration,
  //   });

  //   // 3️⃣ Create worksheet & workbook
  //   const ws = utils.json_to_sheet(rows);
  //   const wb = utils.book_new();
  //   utils.book_append_sheet(wb, ws, "Attendance Report");

  //   // 4️⃣ Export
  //   writeFileXLSX(wb, "attendance-report.xlsx");
  // }, [filterattentancereport]);

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const [scrollY, setScrollY] = useState();
  useEffect(() => {
    const calculateScrollY = () => {
      // const screenHeight = window.innerHeight;
      // const offset = 180; // Adjust this value as needed for headers/footers
      const dynamicHeight = window.innerHeight - 320;
      setScrollY(dynamicHeight);
    };
    calculateScrollY();
    window.addEventListener("resize", calculateScrollY);
    return () => window.removeEventListener("resize", calculateScrollY);
  }, [scrollY]);

  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                department: "",
              }}
              onFinish={getAttendanceReport}
            >
              <Form.Item
                name="duration_type"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  placeholder="Select..."
                  options={REPORT_DURATION_TYPES}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        name="month"
                        rules={[
                          {
                            required: true,
                            message: "",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select..."
                          options={monthList}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.label === "All Employee" ||
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(a, b) => {
                    if (a?.label === "All Employee") return -1;
                    if (b?.label === "All Employee") return 1;
                    return (a?.label ?? "").localeCompare(b?.label ?? "");
                  }}
                  placeholder="Select Employee"
                  options={concat(
                    {
                      value: "",
                      label: "All Employee",
                    },
                    ...STAFF_LIST
                  )}
                  fieldNames={{
                    label: "label",
                    value: "value",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <div className="d-flex align-items-center gap-2">
            <Dropdown
              overlay={sortMenu}
              trigger={["click"]}
              placement="bottomRight"
              getPopupContainer={() => containerRef.current}
            >
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  border: 0,
                }}
              >
                <SortAscendingOutlined />
              </Button>
            </Dropdown>
            <StyledButtonoutlined
              onClick={xport}
              disabled={filterattentancereport.length === 0}
            >
              Export XLSX file
            </StyledButtonoutlined>
          </div>
        </Col>
      </Row>

      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport}
          columns={finalColumns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          scroll={{ y: scrollY }}
          onChange={handleTableChange}
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false
          }
          summary={() => {
            const summaryData = uiTableData.length
              ? uiTableData
              : filterattentancereport;

            let totalWorkMinutes = 0;

            summaryData.forEach((record) => {
              if (record?.checkoutdate && record?.totalworkedhours) {
                // totalworkedhours format = HH:mm
                const [h, m] = record.totalworkedhours.split(":").map(Number);
                totalWorkMinutes += h * 60 + m;
              }
            });

            const totalDuration = minutesToHourMinutes(totalWorkMinutes);

            return (
              <Table.Summary fixed="bottom">
                <Table.Summary.Row
                  style={{
                    background: "#f0f2f5",
                    fontWeight: 600,
                    position: "sticky",
                    bottom: 0,
                    zIndex: 1000,
                  }}
                >
                  {finalColumns.map((col, index) => {
                    // 🔹 First visible column -> show Sub Total
                    if (index === 0) {
                      return (
                        <Table.Summary.Cell key={index}>
                          <b>Sub Total</b>
                        </Table.Summary.Cell>
                      );
                    }

                    // 🔹 Total Work Duration column match
                    if (col.dataIndex === "totalworkedhours") {
                      return (
                        <Table.Summary.Cell key={index}>
                          <b>{totalDuration}</b>
                        </Table.Summary.Cell>
                      );
                    }

                    // 🔹 Empty for others
                    return <Table.Summary.Cell key={index} />;
                  })}
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />

        <Table
          style={{ display: "none" }}
          dataSource={filterattentancereport}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          pagination={false}
          id="Table"
        />
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userList: getUserList(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(Approval);
